/**
 * Tira da peça de e-mail o "fundo de caixa de entrada" e devolve só o cartão
 * (CENTRAL-04.2, emendada em 2026-09-25).
 *
 * O template desenha duas camadas: uma tela de fundo escura com margem, que é o
 * que o e-mail mostra em volta do conteúdo, e dentro dela o cartão de cantos
 * arredondados. No app a tela de fundo vira uma segunda moldura em volta do
 * modal — o overlay já faz esse papel.
 *
 * A regra desce pelos embrulhos de filho único (`div` > `table` > `tbody` > `tr`
 * > `td` > …) e para no último que tem `border-radius`: é o cartão. Onde não há
 * cartão — os templates antigos, de tabela larga em duas colunas —, a peça sai
 * intacta. O pior caso de o template mudar é a moldura voltar, nunca conteúdo
 * perdido: a função só escolhe um nó que contém todo o resto.
 *
 * Roda depois do `sanitizeHtml` e do `pruneEmailChrome`; a poda é que deixa o
 * embrulho de fora com filho único, ao remover o preheader.
 */
export function extractEmailCard(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  let card: Element | null = null;
  let node: Element = doc.body;
  while (node.children.length === 1) {
    node = node.children[0];
    if (node.getAttribute('style')?.includes('border-radius')) card = node;
  }

  return card ? card.outerHTML : doc.body.innerHTML;
}
